import { render, staticRenderFns } from "./QrStand.vue?vue&type=template&id=aa1512a4&"
import script from "./QrStand.vue?vue&type=script&lang=ts&"
export * from "./QrStand.vue?vue&type=script&lang=ts&"
import style0 from "./QrStand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports